import { accountInformationActionType } from "store/actionTypes";

const initialState = {
  userSelfData: {},
  isGetUserSelfDataSuccess: false,
}

const accountInformation = (state = initialState, action) => {
  switch (action.type) {
    case accountInformationActionType.GET_USER_BY_ID:
      return {
        ...state,
        userSelfData: action.payload,
      };
    
    case accountInformationActionType.GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        isGetUserSelfDataSuccess: action.payload,
      };
    
    default:
      return state;
  }
}

export default accountInformation;